var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_1323)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9424 14.1914C17.8843 14.2496 17.8153 14.2958 17.7394 14.3273C17.6635 14.3588 17.5821 14.375 17.4999 14.375C17.4177 14.375 17.3362 14.3588 17.2603 14.3273C17.1844 14.2958 17.1154 14.2496 17.0574 14.1914L9.99986 7.13263L2.94236 14.1914C2.88425 14.2495 2.81526 14.2956 2.73934 14.327C2.66341 14.3585 2.58204 14.3747 2.49986 14.3747C2.41768 14.3747 2.3363 14.3585 2.26038 14.327C2.18446 14.2956 2.11547 14.2495 2.05736 14.1914C1.99925 14.1333 1.95315 14.0643 1.92171 13.9884C1.89026 13.9124 1.87407 13.8311 1.87407 13.7489C1.87407 13.6667 1.89026 13.5853 1.92171 13.5094C1.95315 13.4335 1.99925 13.3645 2.05736 13.3064L9.55736 5.80638C9.61542 5.74818 9.68439 5.702 9.76032 5.67049C9.83625 5.63899 9.91765 5.62277 9.99986 5.62277C10.0821 5.62277 10.1635 5.63899 10.2394 5.67049C10.3153 5.702 10.3843 5.74818 10.4424 5.80638L17.9424 13.3064C18.0006 13.3644 18.0467 13.4334 18.0782 13.5093C18.1098 13.5853 18.126 13.6667 18.126 13.7489C18.126 13.8311 18.1098 13.9125 18.0782 13.9884C18.0467 14.0644 18.0006 14.1333 17.9424 14.1914Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_1323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 -1 20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqarrow);
export default __webpack_public_path__ + "static/media/faqarrow.156c735483433a782a99b569ad891f0d.svg";
export { ForwardRef as ReactComponent };